exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".print-Ae {\n  padding-left: 1rem;\n  margin-top: 1rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/ae-summary/ae-summary.component.scss
// module id = ../../../../../src/app/crm/ae-summary/ae-summary.component.scss
// module chunks = main